import depoimento from "../images/Comunicacao/Depoimentos-Direitos.png";
import stf from "../images/Comunicacao/SesaoSTF.png";
import resp23dir from "../images/Comunicacao/Res23direito.png";
import resp23enf from "../images/Comunicacao/Res23enfermagem.png";
import resp23psi from "../images/Comunicacao/Res23psicologia.png";

// Dados de vídeos
export const videos = [
  {
    id: 1,
    title: "Curso de Direito - Faculdade Cerrado (Depoimentos)",
    thumbnail: depoimento,
    embed: "https://www.youtube.com/embed/cDsIZnHFFOE",
  },
  {
    id: 2,
    title: "Sessão STF - Presença da Faculdade Cerrado",
    thumbnail: stf,
    embed: "https://www.youtube.com/embed/W-i5zhSeg1c",
  },
  {
    id: 3,
    title: "Faculdade Cerrado - Retrospectiva Direito",
    thumbnail: resp23dir,
    embed: "https://www.youtube.com/embed/yAoR_PUFM_Y",
  },
  {
    id: 4,
    title: "Faculdade Cerrado - Retrospectiva Enfermagem",
    thumbnail: resp23enf,
    embed: "https://www.youtube.com/embed/K4895Nh6AAw",
  },
  {
    id: 5,
    title: "Faculdade Cerrado - Retrospectiva Psicologia",
    thumbnail: resp23psi,
    embed: "https://www.youtube.com/embed/OnGsoliDuBk",
  },
];
